import { useEffect, useState } from 'react';

// INSTALAR COMO APLICATIVO (20/10/2026, igual a Central web): o pedido de instalacao do navegador (Chrome/Edge)
// chega logo ao abrir a pagina, as vezes antes da tela montar: fica guardado aqui e quem usa o hook e' avisado pelo evento.
// Ja' instalado (ou Safari/Firefox), o pedido nao chega e o botao nao aparece
const EVENTO_INSTALACAO = 'suporte:instalacao';
let pedidoInstalacao = null;

window.addEventListener('beforeinstallprompt', evento => {
    // sem a faixa automatica do navegador: o botao e' o nosso
    evento.preventDefault();
    pedidoInstalacao = evento;
    window.dispatchEvent(new Event(EVENTO_INSTALACAO));
});

window.addEventListener('appinstalled', () => {
    pedidoInstalacao = null;
    window.dispatchEvent(new Event(EVENTO_INSTALACAO));
});

// podeInstalar: o navegador ofereceu a instalacao; instalar: abre a janela de instalacao do navegador
export function useInstalacao(){

    const [podeInstalar, alterarPodeInstalar] = useState(() => pedidoInstalacao !== null);

    useEffect(() => {
        const atualizar = () => alterarPodeInstalar(pedidoInstalacao !== null);
        window.addEventListener(EVENTO_INSTALACAO, atualizar);
        return () => window.removeEventListener(EVENTO_INSTALACAO, atualizar);
    }, []);

    async function instalar(){

        const pedido = pedidoInstalacao;

        if(!pedido){
            return;
        }

        await pedido.prompt().catch(() => undefined);
        pedidoInstalacao = null;
        alterarPodeInstalar(false);
    }

    return { podeInstalar, instalar };
}

// aberta pelo aplicativo instalado (janela propria) e nao numa aba do navegador; navigator.standalone e' o do iPhone/iPad
export function abertaComoAplicativo(){
    return window.matchMedia('(display-mode: standalone)').matches
        || window.matchMedia('(display-mode: window-controls-overlay)').matches
        || navigator.standalone === true;
}
